import { AppBar, Badge, makeStyles } from '@material-ui/core'
import Tabs from '../../design-components/tabs/src/Tabs'
import Tab from '../../design-components/tabs/src/Tab'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ScreenSizeContext, useThemeContext } from 'providers'

const StyledBadge = withStyles(() => ({
    badge: {
        right: -12,
        top: -3,
        padding: '3px 7px 3px 7px',
        background: '#F76757',
        color: 'white',
        boxShadow: '-1px 2px 1px rgba(0, 0, 0, 0.35)',
        borderRadius: '11px'
    }
}))(Badge)

const styles = theme => ({
    appBarRoot: {
        backgroundColor: '#fff !important', // 33 means opacity 0.2
        boxShadow: 'none !important',
        alignItems: 'start',
        paddingTop: 10,
        flexDirection: 'row',
        zIndex: 1099,
        [theme.breakpoints.up('sm')]: {
            paddingLeft: 0
        },
        [theme.breakpoints.down('xs')]: {
            '& svg': {
                marginRight: '1px!important',
                '& + p': {
                    fontSize: '12px'
                }
            }
        },
        [theme.breakpoints.down('xs')]: {
            '& svg': {
                marginRight: '1px!important',
                '& + p': {
                    fontSize: '12px'
                }
            }
        },
        color: '#0000008a'
    },
    indicator: {
    },
    indicatorSmall: {
        display: 'none'
    },
    tabRoot: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '22px',
        fontFamily: 'Montserrat-medium !important',
        [theme.breakpoints.down('xs')]: {
            padding: '6px 0px'
        }
    },
    labelContainer: {
        width: 'auto',
        padding: 0
    },
    labelIcon: {
        minHeight: 'initial',
        paddingTop: 6
    },
    iconLabelWrapper: {
        flexDirection: 'row',
        textTransform: 'none',
        '& svg': {
            width: '20px',
            height: '18px',
            marginRight: '8px',
            marginBottom: '0px !important'
        }
    },
    selected: {
        background: 'white',
        color: '#000000'
    }

})

const useStyles = makeStyles(styles)

/**
 *
 */
export const makeTabName = t => {
    let tabName = ''
    const array = t.split('-')
    array.forEach((value, key) => {
        tabName += (key === 0 ? value.charAt(0).toUpperCase() : value.charAt(0)) + value.slice(1)
        if (key + 1 !== array.legth) {
            tabName += ' '
        }
    })
    return tabName
}

/**
 *
 */
const HeaderTabs = (props) => {
    const screenSize = useContext(ScreenSizeContext)
    const classes = useStyles({ screenSize })
    const selectedTabId = props.selectedTabId || props.tabs[0].id
    const theme = useThemeContext()

    const onTabClick = async (event, tabId) => {
        const sTabs = tabs
        const stop = await props.onTabSwitch(tabId) === false
        if (stop) return
        sTabs.forEach(tab => (tab.active = tab.id === tabId))
        setTabs([...sTabs])
    }

    const tabMapper = (t) => ({
        id: t.id,
        text: makeTabName(t.id),
        icon: t.icon,
        onClick: (e) => onTabClick(e, t.id),
        active: t.id === selectedTabId
    })

    const [tabs, setTabs] = useState(props.tabs.map(tabMapper))
    const [badges, setBadges] = useState(props.badges)

    useEffect(() => {
        if (props.selectedTabId) {
            const pTabs = props.tabs.map(tabMapper)
            setTabs(pTabs)
        }
    }, [props.selectedTabId])

    useEffect(() => {
        if (badges) {
            const sBadges = badges
            sBadges['user-phones'] = props.incompleteE911Count
            setBadges(sBadges)
        }
    }, [props.incompleteE911Count])

    const smallView = useMemo(() => screenSize.mobile || screenSize.tablet, [screenSize])
    const darkColor = theme.palette.primary.text
    const lightColor = 'white'
    const activeTab = tabs.find(t => t.active === true)

    return <AppBar
        classes={{ root: classes.appBarRoot }}
        position="static"
    >
        <Tabs
            classes={{
                indicator: `${smallView ? classes.indicatorSmall : classes.indicator}`
            }}
            value={activeTab.id}
            onChange={onTabClick}
            aria-label="tabs"
            variant={smallView ? 'scrollable' : 'fullWidth'}
            data-testid='tabs'
        >
            {tabs.map((tab, i) => {
                const Icon = tab.icon
                return (
                    <Tab
                        classes={{
                            root: `${classes.tabRoot} ${!tab.active ? 'inactive' : ''} ${smallView ? 'small' : ''}`,
                            wrapper: classes.iconLabelWrapper,
                            selected: classes.selected,
                            labelIcon: classes.labelIcon
                        }}
                        disableRipple={true}
                        key={tab.id}
                        label={(badges && badges[tab.id])
                            ? (<div>{tab.text}
                                <StyledBadge
                                    data-testid="badge"
                                    badgeContent={badges[tab.id]}
                                /></div>)
                            : tab.text}
                        value={tab.id}
                        icon={(!smallView && Icon) ? <Icon color={tab.active ? darkColor : theme.palette.primary.dark} secondaryColor={lightColor} /> : null}
                        data-testid={`tab-${i}`}
                    />
                )
            })}
        </Tabs>
    </AppBar>
}

HeaderTabs.propTypes = {
    badges: PropTypes.object,
    classes: PropTypes.any,
    incompleteE911Count: PropTypes.number,
    onTabSwitch: PropTypes.func,
    selectedTabId: PropTypes.string,
    smallView: PropTypes.any,
    tabs: PropTypes.array
}

export default HeaderTabs
